import { fromJS } from 'immutable';
import * as actions from '../../actions/maintenance/publicPortal';
import { START, SUCCESS, ERROR } from '../../actions/maintenance/global';
import { fetchingState } from '../../constants';

const initialState = {
  configurationPortal: { data: {}, state: null },
  configurationAppeal: { data: {}, state: null },
  configurationEmail: { data: {}, state: null },
  publicCheckInConfigs: { data: [], state: null },
  workItemDefSubTypes: { data: [], state: null },
  checkInCategories: { data: [], state: null },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case actions.FETCH_CONFIGURATION_PORTAL[START]:
      return state.setIn(
        ['configurationPortal', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_CONFIGURATION_PORTAL[SUCCESS]:
      return state
        .setIn(['configurationPortal', 'state'], fetchingState.LOADED)
        .setIn(
          ['configurationPortal', 'data'],
          fromJS(action.data.results || {}),
        );
    case actions.FETCH_CONFIGURATION_PORTAL[ERROR]:
      return state.setIn(['configurationPortal', 'state'], fetchingState.ERROR);

    case actions.UPDATE_CONFIGURATION_PORTAL[START]:
      return state.setIn(
        ['configurationPortal', 'state'],
        fetchingState.FETCHING,
      );
    case actions.UPDATE_CONFIGURATION_PORTAL[SUCCESS]:
      return state
        .setIn(['configurationPortal', 'state'], fetchingState.LOADED)
        .setIn(
          ['configurationPortal', 'data'],
          fromJS(action.data.results ? action.data.results[0] : {}),
        );
    case actions.UPDATE_CONFIGURATION_PORTAL[ERROR]:
      return state.setIn(['configurationPortal', 'state'], fetchingState.ERROR);

    case actions.FETCH_CONFIGURATION_APPEAL[START]:
      return state.setIn(
        ['configurationAppeal', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_CONFIGURATION_APPEAL[SUCCESS]:
      return state
        .setIn(['configurationAppeal', 'state'], fetchingState.LOADED)
        .setIn(
          ['configurationAppeal', 'data'],
          fromJS(action.data.results || {}),
        );
    case actions.FETCH_CONFIGURATION_APPEAL[ERROR]:
      return state.setIn(['configurationAppeal', 'state'], fetchingState.ERROR);

    case actions.UPDATE_CONFIGURATION_APPEAL[START]:
      return state.setIn(
        ['configurationAppeal', 'state'],
        fetchingState.FETCHING,
      );
    case actions.UPDATE_CONFIGURATION_APPEAL[SUCCESS]:
      return state
        .setIn(['configurationAppeal', 'state'], fetchingState.LOADED)
        .setIn(
          ['configurationAppeal', 'data'],
          fromJS(action.data.results ? action.data.results[0] : {}),
        );
    case actions.UPDATE_CONFIGURATION_APPEAL[ERROR]:
      return state.setIn(['configurationAppeal', 'state'], fetchingState.ERROR);

    case actions.FETCH_CONFIGURATION_EMAIL[START]:
      return state.setIn(
        ['configurationEmail', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_CONFIGURATION_EMAIL[SUCCESS]:
      return state
        .setIn(['configurationEmail', 'state'], fetchingState.LOADED)
        .setIn(
          ['configurationEmail', 'data'],
          fromJS(action.data.results || {}),
        );
    case actions.FETCH_CONFIGURATION_EMAIL[ERROR]:
      return state.setIn(['configurationEmail', 'state'], fetchingState.ERROR);

    case actions.UPDATE_CONFIGURATION_EMAIL[START]:
      return state.setIn(
        ['configurationEmail', 'state'],
        fetchingState.FETCHING,
      );
    case actions.UPDATE_CONFIGURATION_EMAIL[SUCCESS]:
      return state
        .setIn(['configurationEmail', 'state'], fetchingState.LOADED)
        .setIn(
          ['configurationEmail', 'data'],
          fromJS(action.data.results ? action.data.results[0] : {}),
        );
    case actions.UPDATE_CONFIGURATION_EMAIL[ERROR]:
      return state.setIn(['configurationEmail', 'state'], fetchingState.ERROR);

    case actions.FETCH_ALL_PUBLIC_CHECK_CONFIG[START]:
      return state.setIn(
        ['publicCheckInConfigs', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_ALL_PUBLIC_CHECK_CONFIG[SUCCESS]:
      return state
        .setIn(['publicCheckInConfigs', 'state'], fetchingState.LOADED)
        .setIn(['publicCheckInConfigs', 'data'], fromJS(action.data.results));

    case actions.FETCH_ALL_PUBLIC_CHECK_CONFIG[ERROR]:
      return state.setIn(
        ['publicCheckInConfigs', 'state'],
        fetchingState.ERROR,
      );

    case actions.FETCH_WORK_ITEM_DEF_SUBTYPES[START]:
      return state.setIn(
        ['workItemDefSubTypes', 'state'],
        fetchingState.FETCHING,
      );

    case actions.FETCH_WORK_ITEM_DEF_SUBTYPES[SUCCESS]:
      return state
        .setIn(['workItemDefSubTypes', 'state'], fetchingState.LOADED)
        .setIn(['workItemDefSubTypes', 'data'], fromJS(action.data.results));

    case actions.FETCH_WORK_ITEM_DEF_SUBTYPES[ERROR]:
      return state.setIn(['workItemDefSubTypes', 'state'], fetchingState.ERROR);

    case actions.FETCH_CHECKIN_CATEGORIES[START]:
      return state.setIn(
        ['checkInCategories', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_CHECKIN_CATEGORIES[SUCCESS]:
      return state
        .setIn(['checkInCategories', 'state'], fetchingState.LOADED)
        .setIn(
          ['checkInCategories', 'data'],
          fromJS(action.data.results || []),
        );
    case actions.FETCH_CHECKIN_CATEGORIES[ERROR]:
      return state.setIn(['checkInCategories', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
